import React, { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useModal } from '../../../../hooks/useModal';
import { MODAL_NAME_CREATE_FONT } from '../../../../constants/modalNamesConstants';
import ModalComponent from '../../../../core/components/modal/ModalComponent';
import { PanelSubSectionComponent } from '../../../../core/components/oldPanel/OldPanelComponent';
import SelectComponent from '../../../../core/components/select/SelectComponent';
import InputComponent from '../../../../core/components/input/InputComponent';
import ButtonComponent from '../../../../core/components/button/ButtonComponent';
import { useCreateFont } from './useFonts';

const CreateFontModalContainer: FC = () => {
  const { t } = useTranslation();
  const { onCloseModal } = useModal(MODAL_NAME_CREATE_FONT);

  const [fontName, setFontName] = useState('');
  const [alphabetCountryCode, setAlphabetCountryCode] = useState('ru');

  const onFontNameChange = (value: string) => setFontName(value);
  const onAlphabetChange = (value: string) => setAlphabetCountryCode(value);

  const { isLoadingCreateFont, createFont } = useCreateFont();

  const alphabetOptions = [
    {
      text: t('fontCreator.alphabets.russian'),
      value: 'ru',
    },
    {
      text: t('fontCreator.alphabets.english'),
      value: 'en',
    },
    {
      text: t('fontCreator.alphabets.ukrainian'),
      value: 'ua',
    },
    {
      text: t('fontCreator.alphabets.belarusian'),
      value: 'by',
    },
    {
      text: t('fontCreator.alphabets.bashkir'),
      value: 'ru-ba',
    },
    {
      text: t('fontCreator.alphabets.tatar'),
      value: 'ru-ta',
    },
    {
      text: t('fontCreator.alphabets.kazakh'),
      value: 'kz',
    },
    {
      text: t('fontCreator.alphabets.armenian'),
      value: 'am',
    },
    {
      text: t('fontCreator.alphabets.georgian'),
      value: 'ge',
    },
    {
      text: t('fontCreator.alphabets.turkish'),
      value: 'tr',
    },
  ];

  const onClickCreateFont = async () => {
    if (fontName.length && alphabetCountryCode.length) {
      await createFont(fontName, alphabetCountryCode);
      onCloseModal();
    }
  };

  return (
        <ModalComponent title={t('fontCreator.createNewFont')} onClose={onCloseModal}>
            <PanelSubSectionComponent>
                <p className="mb-4">{t('fontCreator.fontNameLabel')}</p>
                <InputComponent onChange={onFontNameChange} value={fontName} placeholder={t('fontCreator.fontNamePlaceholder')} />
            </PanelSubSectionComponent>
            <PanelSubSectionComponent>
                <p className="mb-4">{t('fontCreator.alphabetLabel')}</p>
                <SelectComponent onChange={onAlphabetChange} defaultValue={alphabetCountryCode} options={alphabetOptions} />
            </PanelSubSectionComponent>
            <ButtonComponent className="mt-16" text={t('fontCreator.createButton')} onClick={onClickCreateFont} isLoading={isLoadingCreateFont} />
        </ModalComponent>
  );
};

export default CreateFontModalContainer;
